/* src/app/pages/ui-kit/components/slide-range-view/slide-range-view.component.scss */
.box {
  display: flex;
  align-items: stretch;
  width: 100%;
}
/*# sourceMappingURL=slide-range-view.component.css.map */
